import { REQUEST_ERROR, REQUEST_START, REQUEST_SUCCESS } from "../../../../middlewares/api/actions"
import { DDB_CONNECTION_GET_MDM_CONNECTIONS } from "./actions"

const connectionControlReducer = (state = {
    mdmConnections: null,
}, action) => {
    switch(action.type){
        case REQUEST_START:
            switch(action.label){
                case DDB_CONNECTION_GET_MDM_CONNECTIONS:{
                    return {
                        ...state,
                        mdmConnections: null
                    }
                }
                default:{
                    return {
                        ...state
                    }
                }
            } 
        case REQUEST_SUCCESS:
            switch(action.label){
                case DDB_CONNECTION_GET_MDM_CONNECTIONS:{
                    return {
                        ...state,
                        mdmConnections: action.response
                    }
                }
                default:{
                    return {
                        ...state
                    }
                }
            } 
        case REQUEST_ERROR:
            switch(action.label){
                case DDB_CONNECTION_GET_MDM_CONNECTIONS:{
                    return {
                        ...state,
                        mdmConnections: null
                    }
                }
                default:{
                    return {
                        ...state
                    }
                }
            } 
        default:{
            return {
                ...state
            }
        }
        
    }
}

export default connectionControlReducer